<template>
  <div class='index-container'>
    <top></top>
    <div class="banner-wrapper">
      <van-swipe :autoplay="3000" indicator-color="white">
        <van-swipe-item class="banner-item" v-for="item in bannerList" :key="item.id">
          <img :src="item.image" @click="toBannerUrl(item)">
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="middle-wrapper">
      <div class="item" @click="toSign">
        <img src="../assets/icon/icons8-checked_checkbox@2x.png">
        <span>每日签到</span>
      </div>
      <div class="item" @click="toLottery">
        <img src="../assets/icon/icons8-roulette@2x.png">
        <span>{{userInfo.app.credit_alias}}抽奖</span>
      </div>
      <div class="item" @click="toCreditLog">
        <img src="../assets/icon/icons8-expensive@2x.png">
        <span>{{userInfo.app.credit_alias}}记录</span>
      </div>
      <div class="item" @click="toExchangeLog">
        <img src="../assets/icon/icons8-check@2x.png">
        <span>兑换记录</span>
      </div>
    </div>
    <van-tabs class="tab-wrapper" color="#0d2e52"  title-inactive-color="#000" >
      <van-tab v-for="catalogProduct in catalogProductList" :ellipsis="true" :key="catalogProduct.index" :title="catalogProduct.catalog.name">
        <van-list v-model="catalogProduct.loading" :finished="catalogProduct.finished" @load="getList(catalogProduct)" class="product-wrapper">
          <div class="product-item" v-for="product in catalogProduct.product" :key="product.id" @click="toDetail(product)">
            <img :src="product.images.length ? product.images[0] : defaultImg">
            <p class="product-text">{{product.name}}{{product.spec}}</p>
            <div class="exchange"><div class="exchange-price"><img src="../assets/icon/icons8-expensive_2@2x.png"><span>{{product.credit}}</span></div>
            <p class="exchange-goods">商品价值<span class="price">¥{{product.price}}</span></p></div>
          </div>
        </van-list>
        <div class="nomore" v-if="catalogProduct.finished">没有更多了</div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import top from '@/components/top'
import Vue from 'vue'
import wx from 'weixin-js-sdk'
import { Swipe, SwipeItem } from 'vant'
import { Tab, Tabs } from 'vant'
import { List } from 'vant'
import { mapGetters } from 'vuex'

Vue.use(List)
Vue.use(Tab).use(Tabs)
Vue.use(Swipe).use(SwipeItem)

export default {
  name: 'Index',
  components: { top },
  data() {
    return {
      defaultImg: require('../assets/img/img_sample.png'),
      bannerList: [],
      catalogProductList: []
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'jssdkEnabled'])
  },
  watch: {
    jssdkEnabled: function(value) {
      if (value) {
        wx.onMenuShareTimeline({
          title: '国花瓷积分商城', // 分享标题
          link: 'https://guohuaci.qumahudong.com/store', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: '', // 分享图标
          success: function () {
            // 用户点击了分享后执行的回调函数
            alert('share timeline')
          }
        })
        wx.onMenuShareAppMessage({
          title: '国花瓷积分商城', // 分享标题
          desc: '积分兑好礼', // 分享描述
          link: 'https://guohuaci.qumahudong.com/store', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: '', // 分享图标
          success: function (res) {
            // 用户点击了分享后执行的回调函数
            alert('share to')
            console.log(res)
          }
        })
      }
    }
  },
  mounted() {
  },
  created() {
    this.getBanner()
    this.getCatalog()
    this.shareConfig()
  },

  methods: {
    getBanner() {
      var that = this
      this.axios.get('/system/banner/').then(function(res) {
        that.bannerList = res.data.results
      }).catch(function(error) {
        console.log(error)
      })
    },

    getCatalog() {
      var that = this
      this.axios.get('/product/catalogs/').then(function(res) {
        for (const item of res.data.results) {
          that.catalogProductList.push({ catalog: { id: item.id, name: item.name }, product: [], loading: false, finished: false, next: '/product/?limit=10&catalog=' + item.id })
        }
      }).catch(function(error) {
        console.log(error)
      })
    },

    getList(catalogProduct) {
      this.axios.get(catalogProduct.next).then(function(res) {
        catalogProduct.product = catalogProduct.product.concat(res.data.results)
        catalogProduct.loading = false
        if (res.data.next) {
          catalogProduct.next = res.data.next
        } else {
          catalogProduct.finished = true
        }
      }).catch(function(error) {
        console.log(error)
      })
    },

    toDetail(product) {
      console.log(product)
      this.$router.push({ path: '/goods/detail', query: { id: product.id }})
    },

    toBannerUrl(item) {
      if (item.url) {
        window.location.href = item.url
      }
    },

    toSign() {
      this.$router.push({ path: '/activity/sign' })
    },

    toLottery() {
      this.$router.push({ path: '/activity/lottery' })
    },

    toCreditLog() {
      this.$router.push({ path: '/user/credit/log' })
    },

    toExchangeLog() {
      this.$router.push({ path: '/user/exchange/log' })
    },
    shareConfig() {
      if (this.jssdkEnabled) {
        wx.onMenuShareTimeline({
          title: '国花瓷积分商城', // 分享标题
          link: 'https://guohuaci.qumahudong.com/store', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: '', // 分享图标
          success: function () {
            // 用户点击了分享后执行的回调函数
            alert('share timeline')
          }
        })
        wx.onMenuShareAppMessage({
          title: '国花瓷积分商城', // 分享标题
          desc: '积分兑好礼', // 分享描述
          link: 'https://guohuaci.qumahudong.com/store', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: '', // 分享图标
          success: function (res) {
            // 用户点击了分享后执行的回调函数
            alert('share to')
            console.log(res)
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.index-container{
  background: #ffffff;
  .banner-wrapper{
    margin-top: 56px;
    padding: 5px 0;
    .banner-item{
      text-align: center;
      img{
        width: 355px;
        height: 150px;
        // box-shadow: 0 0 8px 4px rgba(176, 176, 176, 0.5);
        border-radius: 5px;
      }
    }
  }
  .middle-wrapper{
    width: 355px;
    height: 65px;
    border-radius: 5px;
    background-color: #f8f8f8;
    margin: 0 auto 15px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    .item{
      height: 40px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      img{
        width: 20px;
        height: 20px;
      }
      span{
        color: #000000;
        font-size: 12px;
        font-weight: 400;
      }
    }
  }
  .tab-wrapper{
    .product-wrapper{
      padding: 0 13px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      margin-top: 10px;
      .product-item{
        width: 167px;
        height: 220px;
        padding-bottom: 10px;
        margin-bottom: 10px;
        // box-shadow: 0 0 8px rgba(199, 199, 199, 0.5) ;
        border: solid 1px #d3d3d3;
        border-radius: 6px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        .product-text{
          width: 157px;
          align-self: flex-start;
          overflow: hidden;
          text-overflow:ellipsis;
          white-space: nowrap;
          padding: 0 5px;
        }
        .exchange{
          align-self: flex-start;
          padding: 0 5px;
          .exchange-price{
            width: 65px;
          }
          .exchange-goods{
            width: 92px;
            text-align: right;
          }
          .price{
            text-decoration:line-through;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
          }
        }
        img{
          width: 167px;
          height: 167px;
          border-radius: 5px 5px 0 0;

        }
        p{
          color: #4a4a4a;
          font-size: 12px;
          font-weight: 400;
          // width: 150px;
          // height: 18px;
          text-align: center;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }
        div{
          display: flex;
          align-items: center;
          img{
            width: 16px;
            height: 16px;
            margin-right: 5px;
          }
          span{
            color: #f5a623;
            font-size: 12px;
            font-weight: 600;
          }
        }
      }
    }
    .nomore{
      padding: 10px 0;
      text-align: center;
    }
  }
}
</style>
<style lang="scss">
.index-container{
  // .van-tabs__nav--card{
  //   border-radius: 20px;
  //   height: 32px;
  //   top: 6px;
  // }
  .van-tab{
    font-size: 12px;
    font-weight: 400;
    flex: 0 0 93.8px;
  }
  .van-tab--active{
    font-size: 12px;
    font-weight: 600;
    z-index: 2;
  }
  .van-list__loading{
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index.vue